export default "__VITE_ASSET__Dt55R0NU__"